export default __webpack_public_path__ + "static/media/yav@2x.e19fac95.png";